import api from '../../api/userAPI';
import { setErrorNotification } from '../snackbarNotification';

export const FETCH_BEGIN = 'visitRemindner.detail/FETCH_BEGIN';
export const FETCH_SUCCESS = 'visitRemindner.detail/FETCH_SUCCESS';
export const FETCH_FAILED = 'visitRemindner.detail/FETCH_FAILED';

const fetchBegin = () => ({ type: FETCH_BEGIN });
const fetchSuccess = data => ({ type: FETCH_SUCCESS, payload: data });
const fetchFailed = error => ({ type: FETCH_FAILED, payload: error });
export const fetchVisitReminder = ID => async dispatch => {
  dispatch(fetchBegin());

  try {
    const res = await api(`retrieve-visit-reminder?id=${ID}`);

    dispatch(fetchSuccess(res.data.result[0]));
  } catch (error) {
    dispatch(fetchFailed(error.toString()));
    dispatch(setErrorNotification(error.toString()));
  }
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_BEGIN:
      return { ...state, data: null, isLoading: true, error: null };
    case FETCH_SUCCESS:
      return { ...state, data: payload, isLoading: false };
    case FETCH_FAILED:
      return { ...state, isLoading: false, error: payload };

    default:
      return state;
  }
};

export default reducer;

const initialState = {
  data: null,
  isLoading: false,
  error: null
};
